import { InternalAxiosRequestConfig } from 'axios';
import { secureAxiosInstance, secureAxiosInstanceWithErrorMessageInterceptor } from '../../../../api-service';

// The rest of the BFF answers CORS with '*', which the browser rejects for requests that carry cookies.
const requestsNeedingSebSession = [
  '/api/citizen/serviceprovider/medicinecard/commands/createmedicinecardforcitizen',
  '/api/citizen/serviceprovider/medicinecard/queries/getfmksynchronizationpreviewforcitizen',
  '/api/citizen/serviceprovider/medicinecard/commands/synchronizemedicinecardfromfmk',
  '/api/citizen/serviceprovider/medicinecard/commands/registermedicinecardprivacyconsent',
  '/api/citizen/serviceprovider/medicinecard/queries/getmedicinecardprintpdf',
  '/api/citizen/serviceprovider/medicinecard/queries/getdosedispensingcardpdf',
];

function sendSebSessionCookie(requestConfig: InternalAxiosRequestConfig) {
  if (requestsNeedingSebSession.some(path => requestConfig.url?.endsWith(path))) {
    requestConfig.withCredentials = true;
  }
  return requestConfig;
}

export function sendSebSessionCookieWithMedicineCardRequests() {
  secureAxiosInstance.interceptors.request.use(sendSebSessionCookie);
  secureAxiosInstanceWithErrorMessageInterceptor.interceptors.request.use(sendSebSessionCookie);
}
